
import { NavLink, Outlet, useLocation, Navigate } from 'react-router-dom'
import { History, ShieldCheck } from 'lucide-react'

export function GovernanceLayout() {
    const location = useLocation()

    // Redirect to config-history if exact match on /rag/governance
    if (location.pathname === '/rag/governance' || location.pathname === '/rag/governance/') {
        return <Navigate to="/rag/governance/config-history" replace />
    }

    return (
        <div className="flex flex-col h-full bg-[#0A0A0A]">
            {/* Sub-Navigation Header */}
            <div className="flex-shrink-0 border-b border-white/10 bg-[#0F0F0F]">
                <div className="px-6 flex gap-6">
                    <TabLink
                        to="/rag/governance/config-history"
                        icon={<History className="w-4 h-4" />}
                        label="Config History"
                    />
                    <TabLink
                        to="/rag/governance/adaptive-audit"
                        icon={<ShieldCheck className="w-4 h-4" />}
                        label="Adaptive Audit"
                    />
                </div>
            </div>

            {/* Content Area */}
            <div className="flex-1 overflow-y-auto">
                <Outlet />
            </div>
        </div>
    )
}

function TabLink({ to, icon, label }: { to: string; icon: React.ReactNode; label: string }) {
    return (
        <NavLink
            to={to}
            className={({ isActive }) =>
                `flex items-center gap-2 py-4 px-2 border-b-2 transition-all text-sm ${isActive
                    ? 'text-white font-medium border-blue-500'
                    : 'text-gray-400 border-transparent hover:text-gray-300 hover:border-white/10'
                }`
            }
        >
            {icon}
            <span>{label}</span>
        </NavLink>
    )
}
